'use client';

import { useDrawerBody_unstable } from '@fluentui/react-drawer';

/**
 * Returns the state for a DrawerBody component, given its props and ref.
 */
export const useDrawerBody = useDrawerBody_unstable;
